import React from 'react';
import PropTypes from 'prop-types';

import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import IconEdit from 'components/icons/IconEdit';
import { colorBrand } from 'styles/layout/colors';

const PencilIcon = () => (
  <IconEdit className="ml-[.3rem]" width={12} height={12} color={colorBrand} />
);

const PDPZipCodeWrapper = ({ children }) => (
  <span className="!text-base inline-flex flex-1 text-center">{children}</span>
);

PDPZipCodeWrapper.propTypes = {
  children: PropTypes.node,
};

const PDPZipCodeEditLocationUI = ({
  isLoading = false,
  isUserInUS = true,
  isZipCodeFromUserServiceable = true,
  locationToShow,
  toggleUpdateZipCodeSidebar,
  zipCodeFromUser,
}) => {
  if (isLoading) {
    return (
      <PDPZipCodeWrapper>
        <ProgressLoaderDots inline grey />
      </PDPZipCodeWrapper>
    );
  }

  if (zipCodeFromUser && !isZipCodeFromUserServiceable) {
    return (
      <PDPZipCodeWrapper>
        <button
          className="items-center flex focus-visible:outline-offset-4 focus:outline-0 text-brand hover:underline font-bold"
          onClick={toggleUpdateZipCodeSidebar}
          type="button"
          aria-label="Update your location"
        >
          Edit zip code
          <PencilIcon />
        </button>
      </PDPZipCodeWrapper>
    );
  }

  if (!isUserInUS || !locationToShow) {
    return (
      <PDPZipCodeWrapper>
        <button
          className="items-center flex focus-visible:outline-offset-4 focus:outline-0 text-brand font-bold hover:underline"
          onClick={toggleUpdateZipCodeSidebar}
          type="button"
          aria-label="Add your location"
        >
          Add zip
        </button>
      </PDPZipCodeWrapper>
    );
  }

  return (
    <PDPZipCodeWrapper>
      to{' '}
      <button
        className="items-center flex ml-1 mr-1 focus-visible:outline-offset-4 focus:outline-0 text-brand hover:underline font-bold"
        onClick={toggleUpdateZipCodeSidebar}
        type="button"
        aria-label="Update your location"
      >
        {locationToShow}
        <PencilIcon />
      </button>
    </PDPZipCodeWrapper>
  );
};

PDPZipCodeEditLocationUI.propTypes = {
  isLoading: PropTypes.bool,
  isUserInUS: PropTypes.bool,
  isZipCodeFromUserServiceable: PropTypes.bool,
  locationToShow: PropTypes.string,
  toggleUpdateZipCodeSidebar: PropTypes.func,
  zipCodeFromUser: PropTypes.string,
};

export default React.memo(PDPZipCodeEditLocationUI);
